var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "content-wrappper resources-map" },
    [
      _c("div", { staticClass: "row tool-container mr-0 ml-0" }, [
        _c("div", { staticClass: "col-md-12 box-body" }, [
          _vm._m(0),
          _vm._m(1),
          _vm._m(2),
          _c(
            "div",
            {
              staticClass: "dashboard-dropdown d-flex flex-between pl-15 pb-24",
            },
            [
              _c(
                "div",
                { staticClass: "dropdown-container d-flex flex-between" },
                [
                  _c(
                    "div",
                    {
                      staticClass: "mr-30 country-section",
                      class: {
                        "opacity-05":
                          _vm.selectedResource && !_vm.country && !_vm.listView,
                        "": _vm.listView,
                        "": !_vm.listView,
                      },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "country-dropdown-container d-flex align-items-center",
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "country-label-wrapper",
                              class: { "country-label-mapvw": !_vm.listView },
                            },
                            [_vm._m(3)]
                          ),
                          !_vm.listView
                            ? _c(
                                "div",
                                { staticClass: "country-dropdown" },
                                [
                                  _c(
                                    "multiselect",
                                    {
                                      staticClass:
                                        "multiselect-single-dropdown resourcesMapView",
                                      class:
                                        _vm.selectedResource.value !=
                                          "Select All" &&
                                        !_vm.country &&
                                        !_vm.listView
                                          ? "disable-drop-down"
                                          : "",
                                      attrs: {
                                        "allow-empty": false,
                                        "show-labels": false,
                                        searchable: true,
                                        "open-direction": "bottom",
                                        disabled:
                                          _vm.selectedResource.value !=
                                            "Select All" &&
                                          !_vm.country &&
                                          !_vm.listView
                                            ? true
                                            : false,
                                        placeholder: "Select Country",
                                        options: _vm.countryList,
                                      },
                                      on: { input: _vm.countrySelected },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "option",
                                            fn: function (props) {
                                              return _c("span", {}, [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass: "option-desc",
                                                    class:
                                                      _vm.country ==
                                                        "Select All" ||
                                                      _vm.country ==
                                                        props.option
                                                        ? "font-bold"
                                                        : "font-wt-400",
                                                  },
                                                  [_vm._v(_vm._s(props.option))]
                                                ),
                                              ])
                                            },
                                          },
                                        ],
                                        null,
                                        false,
                                        2244114223
                                      ),
                                      model: {
                                        value: _vm.country,
                                        callback: function ($$v) {
                                          _vm.country = $$v
                                        },
                                        expression: "country",
                                      },
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          attrs: { slot: "noResult" },
                                          slot: "noResult",
                                        },
                                        [_vm._v("No matching data")]
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              )
                            : _c(
                                "div",
                                { staticClass: "country-dropdown" },
                                [
                                  _c(
                                    "multiselect",
                                    {
                                      staticClass:
                                        "multiselect-single-dropdown",
                                      attrs: {
                                        showLabels: false,
                                        "close-on-select": true,
                                        "allow-empty": false,
                                        searchable: true,
                                        options: _vm.countryList,
                                        placeholder: "Select Country",
                                      },
                                      on: { input: _vm.countrySelected },
                                      model: {
                                        value: _vm.country,
                                        callback: function ($$v) {
                                          _vm.country = $$v
                                        },
                                        expression: "country",
                                      },
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          attrs: { slot: "noResult" },
                                          slot: "noResult",
                                        },
                                        [_vm._v("No matching data")]
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                        ]
                      ),
                    ]
                  ),
                  !_vm.listView
                    ? _c(
                        "div",
                        {
                          staticClass: "resource-section",
                          class: {
                            "opacity-05": !_vm.selectedResource && _vm.country,
                          },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "resource-dropdown-container d-flex align-items-center",
                            },
                            [
                              _vm._m(4),
                              _c(
                                "div",
                                { staticClass: "resource-dropdown" },
                                [
                                  _c(
                                    "multiselect",
                                    {
                                      staticClass:
                                        "multiselect-single-dropdown resourcesMapView resources",
                                      class:
                                        !_vm.selectedResource.value &&
                                        _vm.country
                                          ? "disable-drop-down"
                                          : "",
                                      attrs: {
                                        "show-labels": false,
                                        "allow-empty": false,
                                        "open-direction": "bottom",
                                        searchable: false,
                                        disabled:
                                          !_vm.selectedResource.value &&
                                          _vm.country
                                            ? true
                                            : false,
                                        placeholder: "Select Resource",
                                        options: _vm.options,
                                        "group-label": "label",
                                        "group-select": false,
                                        "group-values": "options",
                                        "track-by": "value",
                                        label: "label",
                                      },
                                      on: { input: _vm.getListOfCountries },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "option",
                                            fn: function (props) {
                                              return _c("span", {}, [
                                                props.option.$groupLabel &&
                                                props.option.$groupLabel.length
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "group-desc",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            props.option
                                                              .$groupLabel
                                                          )
                                                        ),
                                                      ]
                                                    )
                                                  : _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "option-desc",
                                                        class:
                                                          _vm.selectedResource
                                                            .value ==
                                                            "Select All" ||
                                                          _vm.selectedResource
                                                            .value ==
                                                            props.option.value
                                                            ? "font-bold"
                                                            : "font-wt-400",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            props.option.label
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                              ])
                                            },
                                          },
                                        ],
                                        null,
                                        false,
                                        2650935605
                                      ),
                                      model: {
                                        value: _vm.selectedResource,
                                        callback: function ($$v) {
                                          _vm.selectedResource = $$v
                                        },
                                        expression: "selectedResource",
                                      },
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          attrs: { slot: "noResult" },
                                          slot: "noResult",
                                        },
                                        [_vm._v("No matching data")]
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ]
                          ),
                        ]
                      )
                    : _vm._e(),
                ]
              ),
              _c("div", { staticClass: "clear-button-wrapper" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-block btn-clr emergo-white-button",
                    attrs: { disabled: _vm.disableClear },
                    on: { click: _vm.clearSelection },
                  },
                  [_vm._v(" Clear ")]
                ),
              ]),
            ]
          ),
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col-xs-12 col-md-12 col-lg-12 pl-24 pr-24" },
              [
                _c(
                  "div",
                  { staticClass: "list-view-widget p-15" },
                  [
                    _c("div", { staticClass: "row pt-5" }, [
                      _c("ul", { staticClass: "nav nav-tabs pl-24 pr-24" }, [
                        _c(
                          "li",
                          {
                            staticClass: "nav-item",
                            class: {
                              "selected-view active": !_vm.listView,
                              "unselected-view": _vm.listView,
                            },
                            on: {
                              click: function ($event) {
                                return _vm.toggleView(_vm.listView)
                              },
                            },
                          },
                          [_vm._v(" Map View ")]
                        ),
                        _c(
                          "li",
                          {
                            staticClass: "nav-item",
                            class: {
                              "selected-view active": _vm.listView,
                              "unselected-view": !_vm.listView,
                            },
                            on: {
                              click: function ($event) {
                                return _vm.toggleView(!_vm.listView)
                              },
                            },
                          },
                          [_vm._v(" List View ")]
                        ),
                      ]),
                    ]),
                    _vm.listView
                      ? _c("country-resources-list", {
                          attrs: {
                            dataList: _vm.listViewData,
                            country: _vm.country,
                            EUCountries: _vm.EUCountries,
                          },
                        })
                      : _c("map-view", {
                          attrs: {
                            resources: _vm.resourcesDropDownList,
                            services: _vm.servicesDropDownList,
                            countriesList: _vm.countriesList,
                            filteredCountries: _vm.filteredCountries,
                            validateFilter: _vm.validateFilter,
                            resourceData: _vm.resourceData,
                            serviceData: _vm.serviceData,
                            countrySelection: _vm.countrySelection,
                            EUCountries: _vm.EUCountries,
                          },
                          on: { loaderEvent: _vm.mapLoaderStatus },
                        }),
                  ],
                  1
                ),
              ]
            ),
          ]),
          !_vm.listView
            ? _c("div", { staticClass: "row" }, [
                _vm.selectedResource &&
                _vm.selectedResource.value !== "Select All"
                  ? _c("div", { staticClass: "col-md-12" }, [
                      _c(
                        "div",
                        { staticClass: "header_box" },
                        [
                          _c("div", { staticClass: "list-header" }, [
                            _vm._v("Available in:"),
                          ]),
                          _vm._l(
                            _vm.displayCountryList,
                            function (country, index) {
                              return _c("div", { key: index }, [
                                _vm._v(_vm._s(index)),
                              ])
                            }
                          ),
                          _vm.displayView &&
                          Object.keys(_vm.filteredCountries).length > 5
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "pointer cust-link cursor-pointer",
                                  on: {
                                    click: function ($event) {
                                      _vm.displayView = false
                                    },
                                  },
                                },
                                [_vm._v(" View more ")]
                              )
                            : _vm._e(),
                          !_vm.displayView &&
                          Object.keys(_vm.filteredCountries).length > 5
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "pointer cust-link cursor-pointer",
                                  on: {
                                    click: function ($event) {
                                      _vm.displayView = true
                                    },
                                  },
                                },
                                [_vm._v(" View less ")]
                              )
                            : _vm._e(),
                        ],
                        2
                      ),
                    ])
                  : _vm._e(),
              ])
            : _vm._e(),
        ]),
      ]),
      _c("loader", { attrs: { loadingStatus: _vm.loaderStatus } }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-md-12" }, [
        _c("div", { staticClass: "header_box header-container" }, [
          _c("h4", { staticClass: "heading" }, [_vm._v("Explorer")]),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-md-9 description-column pr-24 pl-24" }, [
        _c(
          "div",
          { staticClass: "header_box description-container pl-0 pr-0" },
          [
            _c("p", [
              _vm._v(
                " This interactive tool helps explore what RAMS has to offer for global market access and ongoing regulatory compliance needs. Emergo by UL’s digital application platform, RAMS, brings together over two decades of Emergo’s regulatory expertise that spans across 60+ countries coupled with a rich suite of easy to use, collaborative technology capabilities. "
              ),
            ]),
          ]
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "pl-15 pr-15" }, [
        _c("div", { staticClass: "header_box products-container" }, [
          _c("h4", { staticClass: "heading" }, [_vm._v("Products Overview")]),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "label-dropdown" }, [
      _c("span", [_vm._v("Country")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "resource-label-wrapper" }, [
      _c("div", { staticClass: "label-dropdown" }, [
        _c("span", [_vm._v("Resource")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }